<div class="pointer-events-auto">

  @if (isHelpCenterWidgetEnabled) {
  <button class="focus-ring fixed bottom-5 right-5 z-[99999] flex h-12 w-12 items-center justify-center rounded-full
             bg-[var(--blue-zodiac)] dark:bg-card text-white text-3xl font-light
             shadow-[0_2px_10px_rgba(0,123,255,0.3)]
             transition-all duration-200 ease-in-out
             hover:bg-[var(--downriver)] hover:scale-105" (click)="togglePanel()" aria-label="Help">
    ?
  </button>
  }

  @if (isPanelOpen) {
  <div>
    <div class="fixed inset-0 z-[99999]" (click)="togglePanel()"></div>

    <div role="dialog" aria-modal="true" aria-labelledby="help-dialog-title" class="fixed bottom-20 right-5 z-[99999] w-80 max-h-[450px] overflow-y-auto
               rounded-xl border bg-white
               p-6 font-['Inter'] shadow-[0_8px_25px_rgba(13,40,79,0.18)]
               animate-[slideUp_0.2s_ease-out]">

      <button
        class="focus-ring absolute top-3 right-4 text-3xl font-light text-gray-500 dark:text-white hover:text-[var(--blue-zodiac)]"
        (click)="togglePanel()">
        &times;
      </button>

      <h2 id="help-dialog-title" class="mb-4 text-lg font-semibold text-[var(--blue-zodiac)] font-sans dark:text-white">
        {{ 'helpWidget.helpCenter' | translate }}
      </h2>

      <ul class="font-sans">
        <li>
          <button class="focus-ring w-full rounded-md px-3 py-3.5 text-left font-medium text-gray-600 dark:text-white
                       transition-all duration-200 hover:bg-blue-50 hover:text-[var(--blue-zodiac)]
                       hover:translate-x-1 dark:hover:bg-white/20" (click)="openDocumentation()">
            {{ 'helpWidget.documentation' | translate }}
          </button>
        </li>

        @if (enableUserback) {
        <li>
          <button class="focus-ring w-full rounded-md px-3 py-3.5 text-left font-medium text-gray-600 dark:text-white
                       transition-all duration-200 hover:bg-blue-50 hover:text-[var(--blue-zodiac)]
                       hover:translate-x-1 dark:hover:bg-white/20" (click)="openFeedback('general')">
            {{ 'helpWidget.feedback' | translate }}
          </button>
        </li>

        <li>
          <button class="focus-ring w-full rounded-md px-3 py-3.5 text-left font-medium text-gray-600 dark:text-white
                       transition-all duration-200 hover:bg-blue-50 hover:text-[var(--blue-zodiac)]
                       hover:translate-x-1 dark:hover:bg-white/20" (click)="openFeedback('bug')">
            {{ 'helpWidget.reportBug' | translate }}
          </button>
        </li>

        <li>
          <button class="focus-ring w-full rounded-md px-3 py-3.5 text-left font-medium text-gray-600 dark:text-white
                       transition-all duration-200 hover:bg-blue-50 hover:text-[var(--blue-zodiac)]
                       hover:translate-x-1 dark:hover:bg-white/20" (click)="openFeedback('feature_request')">
            {{ 'helpWidget.requestFeature' | translate }}
          </button>
        </li>
        }
      </ul>
    </div>
  </div>
  }

  @if (showDocsModal) {

  @if (!isDocsCollapsed) {
  <div class="fixed inset-0 z-[99999]" (click)="toggleDocsCollapse()"></div>
  }

  <div class="fixed bottom-20 right-5 z-[99999] flex h-[75vh] md:w-[450px] sm:w-auto flex-col rounded-xl
             border bg-white shadow-[0_8px_30px_rgba(0,0,0,0.2)]
             transition-[width,transform] duration-300 ease-out animate-[slideUp_0.3s_ease-out]"
    [class.help-docs-expanded]="isDocsExpanded"
    [class.translate-x-[calc(100%-50px)]]="isDocsCollapsed">

    <div class="flex items-center justify-between rounded-t-xl border-b border-[var(--blue-zodiac)]
                  bg-[var(--blue-zodiac)] px-5 py-6">

      <button class="focus-ring-white flex h-7 w-7 items-center justify-center rounded text-3xl font-light text-white
                 transition hover:bg-white/20" (click)="toggleDocsCollapse()">
        {{ isDocsCollapsed ? '‹' : '›' }}
      </button>

      <h2 class="text-lg font-semibold text-white">{{ 'helpWidget.documentation' | translate }}</h2>

      <div class="flex items-center gap-1">
        <a [href]="docsUrlString" target="_blank" rel="noopener noreferrer"
          class="focus-ring-white hidden md:flex h-7 w-7 items-center justify-center rounded text-lg font-light text-white
                 transition hover:bg-white/20" [attr.aria-label]="'helpWidget.openInNewTab' | translate"
          [title]="'helpWidget.openInNewTab' | translate">
          ↗
        </a>

        <button class="focus-ring-white hidden md:flex h-7 w-7 items-center justify-center rounded text-white
                 transition hover:bg-white/20" (click)="toggleDocsExpand()"
          [attr.aria-label]="(isDocsExpanded ? 'helpWidget.collapseWidth' : 'helpWidget.expandWidth') | translate"
          [title]="(isDocsExpanded ? 'helpWidget.collapseWidth' : 'helpWidget.expandWidth') | translate">
          @if (isDocsExpanded) {
          <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M9 9V4.5M9 9H4.5M9 9 3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5 5.25 5.25" />
          </svg>
          } @else {
          <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9M20.25 20.25h-4.5m4.5 0v-4.5m0 4.5L15 15" />
          </svg>
          }
        </button>

        <button class="focus-ring-white flex h-7 w-7 items-center justify-center rounded text-3xl font-light text-white
                 transition hover:bg-white/20" (click)="closeDocsModal()">
          &times;
        </button>
      </div>
    </div>

    <iframe [src]="docsUrl" class="flex-1 w-full rounded-b-xl border-0" allow="clipboard-write" [attr.title]="'Documentation for ' + contextKey">
    </iframe>
  </div>
  }

</div>